import { Progressbar } from './Progressbar';
import { ChapterList } from './ChapterList';
import styles from './styles.module.scss';
import { ArrowRight } from '../../../../../../../../ui/icons/ArrowRight';
import { AppText } from '../../../../../../../../ui/text/AppText';
import { useLocalization } from '../../../../../../../../lib/hooks/useLocalization';
import { isLength } from '../../../../../../../../lib/util/helpers';
import { TemplateTypes } from '../../../../../../../../lib/models/TemplateTypes';
import { setHistoryPages } from '../../hooks/getHistoryPage';
import { useWindowResize } from '../../../../utils/hooks/useWindowResize';
import cn from 'classnames';

const TABLET_WIDTH = 850;

export function Sidebar({
  pagesFlow,
  colors,
  showChapterIds,
  fonts,
  setPagesFlow,
  setPageHistory,
  currentElements,
  chapterIconMedia,
  handleToggleSidebarTablet,
  footer,
}) {
  const { windowWidth } = useWindowResize();
  const isTablet = windowWidth <= TABLET_WIDTH;
  const { text } = useLocalization().translations.unique.components.productBasedFinder.sidebar.button;
  const { allPages, currentPageId, currentElementsIds, currentFlowElement } = pagesFlow;
  const resultPage = allPages.find(page => page.elements.find(el => el.templateType === TemplateTypes.RESULT));
  const handleGoResult = () => {
    setPagesFlow(prev => ({
      ...prev,
      currentPageId: resultPage?.id,
      prevPageIds: [...prev.prevPageIds, currentPageId],
      currentFlowElement: isLength(resultPage?.elements) ? resultPage.elements[0] : null,
      currentElementsIds: isLength(resultPage?.elements) ? [...prev.currentElementsIds, resultPage.elements[0].id] : [],
      // completed: true,
    }));
    setHistoryPages(allPages, currentPageId, currentElementsIds, setPageHistory, currentFlowElement);
    handleToggleSidebarTablet();
  };

  const showResultButton = resultPage?.elements?.find(el => el?.content?.productBasedFinder)?.content?.productBasedFinder?.showResultButton ?? false;

  return (
    <div className={cn(styles.sidebar, isTablet && styles.sidebar_tablet)}>
      <div className={styles.inner}>
        <Progressbar pagesFlow={pagesFlow} footer={footer} colors={colors} showChapterIds={showChapterIds} fonts={fonts} />
        <ChapterList
          pagesFlow={pagesFlow}
          colors={colors}
          showChapterIds={showChapterIds}
          fonts={fonts}
          setPagesFlow={setPagesFlow}
          setPageHistory={setPageHistory}
          currentElements={currentElements}
          chapterIconMedia={chapterIconMedia}
        />
      </div>
      {showResultButton && (
        <div className={styles.buttonWrapper}>
          <button
            type='button'
            className={styles.button}
            onClick={handleGoResult}
            style={{
              backgroundColor: colors.primaryColor,
              fontWeight: 700,
              fontSize: fonts.headlineFourth.fontSize,
              fontFamily: fonts.headlineFourth.font,
            }}
          >
            <AppText
              textValue={text}
              className={styles.button_text}
              style={{
                fontFamily: fonts.body.font,
              }}
            />
            <ArrowRight />
          </button>
        </div>
      )}
    </div>
  );
}
